
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'billing-templates-form-field-reference',
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: String
        }
    }
})
